import Dropzone from "react-dropzone";
import { useTranslation } from "react-i18next";

import { useToast } from "hooks/toast";

import {
  ClickLocationText,
  ContainerDivDropzone,
  ContainerLogo,
  DropFileContainer,
  DropFileInput,
  DropLocationText,
} from "./styles";
import { DropdownGlobal } from "../../../../../components/DropdownGlobal";
import { getListYesOrNoAux } from "../../constants";

interface LogoCustomProps {
  setEditedValue: (e: any) => void;
  setCustomerLogo: any;
  editedValue: string;
  onChangeFiles: any;
  customerLogo: any;
  fieldError: boolean;
  selectedYesOrNoName: any;
}

const LogoCustom = ({
  setEditedValue,
  setCustomerLogo,
  editedValue,
  onChangeFiles,
  customerLogo,
  selectedYesOrNoName,
  fieldError,
}: LogoCustomProps) => {
  const { t } = useTranslation();
  const { addToast } = useToast();
  const listYesOrNoAux = getListYesOrNoAux(t);
  return (
    <ContainerLogo>
      <DropdownGlobal
        labelName={t("systemConfiguration.logo.addLogo")}
        options={listYesOrNoAux}
        error={fieldError}
        setSelected={(e: any) => {
          setEditedValue(String(e));
          String(e) === "0" && setCustomerLogo(null);
        }}
        required={false}
        editDropdown={selectedYesOrNoName}
        defaultValue={selectedYesOrNoName}
      />
      {editedValue !== "0" && editedValue !== null && (
        <DropFileContainer error={false}>
          <Dropzone
            accept={{ "image/*": [".png", ".jpeg", ".jpg"] }}
            maxSize={5 * 1024 * 1024}
            onDrop={(acceptedFiles) => {
              onChangeFiles(acceptedFiles[0]);
            }}
            onDropRejected={(fileRejections) => {
              const isTooLarge = fileRejections[0]?.errors?.some(
                (e: any) => e.code === "file-too-large",
              );
              addToast({
                type: "warning",
                title: isTooLarge
                  ? t("attachment.fileTooLarge")
                  : t("attachment.invalidFileType"),
                description: isTooLarge
                  ? t("attachment.logoSizeLimit")
                  : t("attachment.invalidFileTypeDescription"),
              });
            }}
          >
            {({ getRootProps, getInputProps, isDragActive }) => (
              <ContainerDivDropzone
                {...getRootProps()}
                isDragActive={isDragActive}
                error={false}
              >
                {isDragActive ? (
                  <ClickLocationText>
                    {t("systemConfiguration.logo.dropHere")}
                  </ClickLocationText>
                ) : (
                  <>
                    {customerLogo && (
                      <img
                        src={customerLogo}
                        style={{
                          marginBottom: 10,
                          height: 50,
                          objectFit: "contain",
                        }}
                        alt=""
                      />
                    )}
                    <DropLocationText>
                      {t("systemConfiguration.logo.dropFileHereOr")}
                    </DropLocationText>
                    <ClickLocationText>
                      {t("systemConfiguration.logo.clickToLocate")}
                    </ClickLocationText>
                  </>
                )}
                <DropFileInput {...getInputProps()} />
              </ContainerDivDropzone>
            )}
          </Dropzone>
        </DropFileContainer>
      )}
    </ContainerLogo>
  );
};

export default LogoCustom;
